import React from 'react';
import { useTranslation } from 'react-i18next';
import { TranslationKey } from '../../../i18n/translationKeys';
import type { SyncStartDateFeedbackProps } from './types';

/** Inline feedback under the date picker: the save outcome, then whether a full sync is still owed. */
export const SyncStartDateFeedback: React.FC<SyncStartDateFeedbackProps> = ({
    status,
    validationError,
    resyncOutcome,
}) => {
    const { t } = useTranslation();

    const saveMessage = validationError
        ? { text: validationError, tone: 'text-danger' }
        : status === 'save-error'
            ? { text: t(TranslationKey.SyncStartDate.ErrorSaveFailed), tone: 'text-danger' }
            : status === 'saved'
                ? { text: t(TranslationKey.SyncStartDate.SaveSuccess), tone: 'text-success' }
                : null;

    const resyncNote = resyncOutcome ? t(TranslationKey.SyncStartDate.ResyncLater) : null;

    return (
        <>
            {saveMessage && (
                <p data-testid="sync-start-date-status" className={`${saveMessage.tone} text-s`}>
                    {saveMessage.text}
                </p>
            )}
            {resyncNote && (
                <p data-testid="sync-start-date-resync-note" className="text-primary-700 text-s">
                    {resyncNote}
                </p>
            )}
        </>
    );
};
